import React from 'react'
import PropTypes from 'prop-types'

import Form from 'component/utils/Form'
import HierarchySelectNew from 'component/hierarchy/HierarchySelectNew'
import HierarchySubtypeSelectNew from 'component/hierarchy/HierarchySubtypeSelectNew'
import CloseIconSVG from 'component/svgComponents/close'


const ALL = 'all'

const FIELDS = ['sectionList', 'subtypeList']

class SideFilterForm extends React.Component {
  static propTypes = {
    initialValues: PropTypes.object.isRequired,
    closeFilter: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    values: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    show: PropTypes.bool,
    setValueToField: PropTypes.func.isRequired,
    fields: PropTypes.any.isRequired,
  }

  state = {
    values: {},
  }

  handleSubmit = (event) => {
    event.preventDefault()
    const { values, onSubmit } = this.props
    const { subtypeList } = values

    const sectionIdList = !values.sectionList
      ? []
      : values.sectionList.reduce((acc, cur) => {
          if (cur.value !== ALL) {
            return [...acc, cur.value]
          }

          return [...acc]
        }, [])

    const subtypeIdList = !subtypeList
      ? []
      : subtypeList.reduce((acc, each) => {
          if (each.value !== ALL) {
            return [...acc, each]
          }

          return [...acc]
        }, [])

    const params = {
      sectionIdList,
      subtypeList: subtypeIdList,
    }

    onSubmit(params)
  }

  handleChange = (field, values, remove) => {
    const { setValueToField } = this.props

    const formattedValues = values || []

    setValueToField(field, formattedValues)

    remove.forEach((item) => setValueToField(item, []))
  }

  render() {
    const {
      translate,
      closeFilter = () => {},
      show,
      values,
      auth: { user },
    } = this.props

    return (
      <div className={`right-filter-container ${!show ? 'hidden' : ''}`}>
        <CloseIconSVG className="right-filter-svg" onClick={closeFilter} />
        <h3 className='margin-bottom-triple'>
          <strong>{translate('mobile.filter')}</strong>
        </h3>

        <div>
          <HierarchySelectNew
            label={translate('section')}
            id='sectionList'
            name='sectionList'
            onChange={(values) =>
              this.handleChange('sectionList', values, ['subtypeList'])
            }
            placeholder='select.section'
            query={{ level: 2 }}
            selected
            translate={translate}
            user={user}
            value={values.sectionList}
            isMulti
            required
          />
        </div>

        <div>
          <HierarchySubtypeSelectNew
            id='subtypeList'
            field='subtypeList'
            name='subtypeList'
            label={translate('subType')}
            disabled={(values.sectionList || '').length === 0}
            noOptions={(values.sectionList || '').length === 0}
            onChange={(values) => this.handleChange('subtypeList', values, [])}
            placeholder='select.subtype'
            query={{ sectionIdList: values.sectionList }}
            translate={translate}
            user={user}
            value={values.subtypeList}
            isMulti
            required
          />
        </div>

        <button
          className='btn btn-primary button-full'
          onClick={this.handleSubmit}
          type='button'
        >
          {translate('btn.filter')}
        </button>
      </div>
    )
  }
}

export default Form({ fields: FIELDS })(SideFilterForm)
export { SideFilterForm }
